(function () {
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      const isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
    });
  }

  const desktopDropdowns = Array.from(document.querySelectorAll('[data-nav-dropdown]'));

  function closeDropdowns(except) {
    desktopDropdowns.forEach(function (dropdown) {
      if (dropdown !== except) dropdown.removeAttribute('open');
    });
  }

  desktopDropdowns.forEach(function (dropdown) {
    const summary = dropdown.querySelector('summary');
    const panel = dropdown.querySelector('.dropdown-panel');
    let closeTimer;

    if (summary) {
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        const willOpen = !dropdown.hasAttribute('open');
        closeDropdowns(dropdown);
        if (willOpen) dropdown.setAttribute('open', '');
        else dropdown.removeAttribute('open');
      });

      summary.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') dropdown.removeAttribute('open');
      });
    }

    dropdown.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      closeDropdowns(dropdown);
      dropdown.setAttribute('open', '');
    });

    dropdown.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        dropdown.removeAttribute('open');
      }, 180);
    });

    if (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    }
  });

  document.addEventListener('click', function (event) {
    desktopDropdowns.forEach(function (dropdown) {
      if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDropdowns();
  });

  document.querySelectorAll('[data-review-slider]').forEach(function (slider) {
    const cards = Array.from(slider.querySelectorAll('.review-card'));
    const prev = slider.querySelector('[data-review-prev]');
    const next = slider.querySelector('[data-review-next]');
    let index = cards.findIndex(function (card) { return card.classList.contains('is-active'); });
    if (index < 0) index = 0;

    function showCard(nextIndex) {
      cards.forEach(function (card) { card.classList.remove('is-active'); });
      index = (nextIndex + cards.length) % cards.length;
      cards[index].classList.add('is-active');
    }

    if (prev) prev.addEventListener('click', function () { showCard(index - 1); });
    if (next) next.addEventListener('click', function () { showCard(index + 1); });
  });
})();
